module.exports = __webpack_public_path__ + "static/media/warning.637967cf.svg";